import React from 'react'
import BoothDetail from '../../components/booth/BoothDetail'

export default function BoothDetailPage() {
  return (
    <div>
      <BoothDetail/>
    </div>
  )
}
